import { render, staticRenderFns } from "./VTableProPatientRecords.vue?vue&type=template&id=2d58a648"
import script from "./VTableProPatientRecords.vue?vue&type=script&lang=js"
export * from "./VTableProPatientRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports